// extracted by mini-css-extract-plugin
module.exports = {"hero-image-wrapper":"_10dlF"};